import React from 'react';
import './Error.css'; 
function TokenError() {
  return (
    <div className="submit_error wrapper">
      <h1>トークンエラーが発生しました。</h1> 
      <div >
        <h3>メール経由でリンクをお試しください。</h3>
        <h3>リンクの有効期限が切れていないかお確かめ下さい。</h3>
        <h3>最初からやり直して下さい。</h3>
      </div>
      <div className='error_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default TokenError;